import script from "./AllList.vue?vue&type=script&setup=true&lang=js"
export * from "./AllList.vue?vue&type=script&setup=true&lang=js"

import "./AllList.vue?vue&type=style&index=0&id=62ebe9a9&lang=css"

const __exports__ = script;

export default __exports__